import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { ProviderLinkStatus } from '@app/src/types/organizations'
import React from 'react'
import type { ResourceCollectionSceneProps } from '../../ResourceCollectionScene'
import BaseProviderScene from './BaseProviderScene'
import { ProviderTabs } from './ProvidersScene'

type ConnectedProvidersSceneProps = {
  relatedContentFilter?: FilterGroup[]
  allowedFilters: string[]
} & Omit<ResourceCollectionSceneProps, 'title'>

const ConnectedProvidersScene: React.FC<ConnectedProvidersSceneProps> = ({
  relatedContentFilter = [],
  allowedFilters,
  ...props
}) => {
  const implicitFilters = [
    {
      name: 'linkStatus',
      filters: [
        {
          operator: Operators.EqualTo,
          value: ProviderLinkStatus.Connected,
        },
      ],
    },
    ...relatedContentFilter,
  ]

  return (
    <BaseProviderScene
      implicitFilters={implicitFilters}
      allowedFilters={allowedFilters}
      resourceView={ProviderTabs.Connected}
      isConnectedProvidersPage
      {...props}
    />
  )
}
export default ConnectedProvidersScene
